import React from "react";
import HeaderInner from "../header/HeaderInner";
import Pricing from "./breadcrumb/Pricing";
import Footer from "../elements/Footer";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

// DATA
import { DataNav } from "../data/DataNav";
import Breadcrumb from "./Breadcrumb";

function OurPricing() {
  const dataBreadcrumb = DataNav[5];

  return (
    <div className="pricing-inner-page">
      <HeaderInner />
      <Breadcrumb props={dataBreadcrumb} />

      {/* Start pricing area  */}
      <div className="faq-area faq-style-one faq-bg-image bg_image tmp-section-gap mt-dec--180">
        <div className="container pt--180">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="faq-accordion">
                <img src="assets/images/politique-qualite.png" alt="" />

                <div className="faq-buttom"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End pricing area  */}
      <Footer />
    </div>
  );
}

export default OurPricing;
